// Everything a catalog card shows comes from the product as edited in the Medusa Admin: title,
// subtitle, description, thumbnail/images and the `metadata` keys below. Only generic fallbacks
// live here, so any published product renders without a storefront change.
// Metadata keys (all optional, plain strings):
//   code              label in `blend.<code>` (defaults to the handle)
//   notes             tasting notes, comma separated
//   origin, producer, variety, roast, weight, score
//   color             accent color, hex (#6D2E91)
//   image_background  image backdrop, hex (#000000)

const SPEC_LABELS = {
    origin: 'origem',
    producer: 'produtor',
    variety: 'variedade',
    roast: 'torra',
    weight: 'peso',
};

const DEFAULT_COLOR = '#6D2E91';
const DEFAULT_IMAGE_BACKGROUND = '#000';
const DEFAULT_IMAGE = '/logo-embalagem-preto.png';
const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

const text = (value) => (typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '');
const hex = (value, fallback) => (HEX_COLOR.test(text(value)) ? text(value) : fallback);

function notesFrom(value) {
    const list = Array.isArray(value) ? value : text(value).split(/[,\n]/);
    return list.map(text).filter(Boolean);
}

// The Store API only returns published products; this also drops anything explicitly unpublished.
export const isListed = (product) => !product.status || product.status === 'published';

export function toBlendContent(product) {
    const metadata = product.metadata || {};
    const specs = Object.entries(SPEC_LABELS)
        .map(([key, label]) => ({ key, label, value: text(metadata[key]) }))
        .filter((spec) => spec.value);

    return {
        slug: text(metadata.code) || product.handle,
        name: product.title,
        tagline: text(product.subtitle) || text(product.description),
        notes: notesFrom(metadata.notes),
        specs,
        score: text(metadata.score),
        color: hex(metadata.color, DEFAULT_COLOR),
        imageBackground: hex(metadata.image_background, DEFAULT_IMAGE_BACKGROUND),
        image: product.thumbnail || product.images?.[0]?.url || DEFAULT_IMAGE,
    };
}
